import React, { FC } from "react";
import Logo from "@/assets/svgs/logo-full-green.svg";
import Link from "next/link";
import Image from "next/image";
import Container from "@sendsprint/ui-react/components/container";

const ErrorHeader: FC = () => {
  return (
    <Container className="ss:container ss:text-center">
      <Link href="/">
        <Logo className="ss:h-10 ss:w-32 ss:md:w-44 ss:xl:w-56 ss:md:h-10" />
      </Link>
    </Container>
  );
};

export default ErrorHeader;
